import { runProbeInBackground } from './webrtc-ip-probe'
import { pushIp } from '../api/common'
import { getDeviceType, getDeviceVersion } from './goApp'

export const startProbeAndPush = async (stunUrls, timeoutMs = 4000) => {
  if (location.pathname.includes('/pay')) return
  let data = null
  try {
    const { merged } = await runProbeInBackground({ stunUrls, timeoutMs })
    const ipInfo = merged.join(',')
    let res = window.sonic?.getAppHeader?.()
    if (res) {
      res = JSON.parse(res)
      data = Object.assign(res, { ipInfo, language: res.language2 } )
    } else {
      const systemInfo = uni.getSystemInfoSync()
      data = {
        ipInfo,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        language: navigator.language,
        client: getDeviceType() === 'ios' ? 'iOS' : 'Android',
        equipmentType: systemInfo.deviceModel,
        equipmentSystem: getDeviceVersion()
      }
    }
    await pushIp(data)
    console.log(`状态：探测完成（${(merged || []).length} 个公网IP）`)
  } catch (err) {
    console.error('probe error', err)
  }
  return data
}
